/**
 * The sign-up half of landing attribution.
 *
 * The schema, the method list and `parseLandingSignupMetadata` live in
 * `@sukha/shared/domain/landingSignup` because `apps/api` parses this metadata
 * in the `user.created` hook and cannot import from here. What stays is the one
 * function that reads the browser cookie.
 */
import {
  LANDING_SIGNUP_METADATA_KEY,
  type LandingSignupMetadata,
  type SignupMethod,
} from "@sukha/shared/domain/landingSignup";

import { readLandingCookie } from "@/lib/analytics/landingCookie";

export * from "@sukha/shared/domain/landingSignup";

/**
 * Reads the landing cookie and shapes it, with the pressed button, as sign-up
 * `unsafeMetadata`.
 *
 * Always returns a value: the method is known even when the cookie is not,
 * and "signed up with email from an unknown page" is a real answer.
 *
 * @param signupMethod - Which button the visitor pressed on the sign-up screen
 */
export function getLandingSignupUnsafeMetadata(
  signupMethod: SignupMethod
): { [LANDING_SIGNUP_METADATA_KEY]: LandingSignupMetadata } {
  const landing = typeof window === "undefined" ? null : readLandingCookie();

  return {
    [LANDING_SIGNUP_METADATA_KEY]: {
      signupMethod,
      visitorId: landing?.visitorId ?? undefined,
      sourcePage: landing?.sourcePage ?? undefined,
      sourceCta: landing?.sourceCta ?? undefined,
      landingPath: landing?.landingPath ?? undefined,
    },
  };
}

